import { TSelectOption } from '@/common/types/select';
import { getCurrentYear } from '@/common/utils/year';

import type { TDashboardMainFilter } from '../types/dashboards';

export const DEFAULT_DASHBOARDS_FILTER: TDashboardMainFilter = {
  year: String(getCurrentYear()),
};

export const DASHBOARDS_INDICATOR_LINKS = [
  'EventsVES',
  'ActiveAgreements',
  'ProjectsWithRegions',
  'ProjectsWithNations',
];

export const DASHBOARDS_INDICATOR_TOOLTIPS = [
  'Мероприятия ВЭД с участием органов государственной власти субъекта РФ',
  'Информация о соглашениях, меморандумах, протоколах, контрактах и иных документах о сотрудничестве, заключенных субъектами РФ с иностранными партнерами в рамках внешнеэкономических связей региона в отчетном периоде',
  'Учитываются инвестиционные проекты в субъекте РФ на стадии реализации или подготовки, сопровождаемые органами власти',
  'Учитываются инвестиционные проекты в иностранном государстве на стадии реализации или подготовки, сопровождаемые органами власти субъекта РФ, а также инициативы субъектов РФ по развитию международного сотрудничества, включая совместные производства и туристические проекты',
];

export const DASHBOARDS_INDICATOR_WORD_FORMS: Record<string, [string, string, string]> = {
  мероприятий: ['мероприятие', 'мероприятия', 'мероприятий'],
  соглашений: ['соглашение', 'соглашения', 'соглашений'],
  проектов: ['проект', 'проекта', 'проектов'],
  мест: ['место', 'места', 'мест'],
};

export const DASHBOARDS_STORAGE_KEY = 'dashboards';

export const REGION_DASHBOARDS_STORAGE_KEYS = 'regionDashboards';

export const ALL_YEAR_OPTION: TSelectOption<string> = { label: 'За все время', value: '1' };

export const DASHBOARDS_RATING_CARD_TITLES = {
  HIGHEST: 'Субъекты РФ с наивысшим рейтингом активности',
  LOWEST: 'Субъекты РФ с наименьшим рейтингом активности',
};

export const SIGNIFICANT_EVENT_LEGEND =
  '*Значимое мероприятие — это мероприятие, которое проводится при участии Президента Российской Федерации, Председателя Правительства Российской Федерации, Председателя Совета Федерации Федерального Собрания Российской Федерации, федеральных министров, полномочных представителей Президента в федеральных округах, губернаторов.';

export const VES_EXPORT_REGION_EFFECTIVNESS_RATING_EXCEL_SORT_ORDER = {
  ASCENDING: 0,
  DESCENDING: 1,
} as const;
